<script setup lang="ts">
  import { computed } from 'vue'
  import { useModalStack } from '@gat-ship/vue-components'
  import PortProvider from './PortProvider.vue'
  import PortDetailModal from '../modals/PortDetailModal.vue'
  import {
    toValidPortSection,
    type PortDetailSection
  } from '../detail-modal/port-detail-modal-sections'

  // Open-state, the port location code, and active section come from this
  // modal's entry in the central ordered stack (the `?modals=` codec owns the
  // URL).
  //
  // Intentional clone of the agency / tenant-user detail-modal providers: every
  // central-host detail modal repeats this entry/open/update/section seam, each
  // owning a distinct KIND and param codec. Not worth a shared abstraction.
  // fallow-ignore-next-line code-duplication
  const KIND = 'port'
  const stack = useModalStack()
  const entry = computed(() =>
    stack.entries.value.find((item) => item.kind === KIND)
  )

  function updateParams(patch: Record<string, string>): void {
    const current = entry.value
    if (!current) return
    stack.update(KIND, { ...current.params, ...patch })
  }

  const open = computed({
    get: () => entry.value != null,
    set: (value) => {
      if (!value) stack.close(KIND)
    }
  })
  const locationCode = computed(() => entry.value?.params.locationCode)
  const activeSection = computed<PortDetailSection>({
    get: () => toValidPortSection(entry.value?.params.portSection ?? null),
    set: (section) => updateParams({ portSection: section })
  })
</script>

<template>
  <PortProvider :location-code="locationCode">
    <PortDetailModal v-model:open="open" v-model:section="activeSection" />
  </PortProvider>
</template>
